export const themeStyles = {
  primaryColor: "#09213c",
  secondaryColor: "rgb(253, 199, 11)",
  tertiaryColor: "rgb(137,207,240)",
  secondaryTextColor: "black",
  textColor: "rgb(110,127,157)",
};
